/** @format */

export const NAV_KEYS = {
  SELL: 'SELL',
  BUY: 'BUY',
  APPRAISE: 'APPRAISE',
  ABROAD: 'ABROAD',
  INVEST: 'INVEST',
  MONITOR: 'MONITOR',
  RENOVATE: 'RENOVATE',
  FOR_SALE: 'FORSALE',
  VISNINGSKLAR: 'visningsklar',
  BUILD_PROPERTY: 'build_property'
};
